<template>
    <div class="question">
        <form id="myForm" @submit.prevent>
            <div class="question-item">
                <div class="question-number">
                    {{ __t('Запитання') }} <strong>{{ currentQuestion + 1 }}</strong> {{ __t('з') }} <strong>{{
                        q_length
                    }}</strong>
                </div>
                <div class="question-text">
                    {{ __t('Введіть, будь ласка, Ваші контактні дані.') }}
                </div>
                <div class="hint" v-html="contactFormDescription"></div>
                <div class="question-form">
                    <div v-for="q in form_question" class="form-field">
                        <label>
                            {{ q.title }}:
                        </label>
                        <input
                            type="text" :pattern="q.mask && q.mask.slug === 'phone' ? '[0-9]*' : ''"
                            :inputmode="q.mask && q.mask.slug === 'phone' ? 'numeric' : ''"
                            :class="q.mask ? q.mask.slug : ''"
                            :name="q.name"
                            :input_name="q.input_name"
                            @input="checkInput"
                            @blur="checkInput">
                    </div>
                </div>
            </div>
            <a href="javascript:;" class="back-btn" :class="{hidden: currentQuestion == 0}"
               @click="setPrevQuestion">{{ __t('Назад') }}</a>

            <button @click="saveData" :class="{disabled: !form_valid}">
                <span v-if="currentQuestion+1 == q_length">{{ __t('Відправити') }}</span>
                <span v-if="currentQuestion+1 != q_length">{{ __t('Далі') }}</span>
            </button>

        </form>
    </div>
</template>

<script>

export default {
    name: 'Form',
    props: ['q_length', 'formData', 'form_question', 'currentQuestion', 'contactFormDescription'],
    data() {
        return {
            form_valid: false
        }
    },
    mounted() {
        /*input: event => this.$emit('input', event.target.value)*/

        $('input.ten_digits').mask('SSSSSSSSSS', {
            'translation': {
                S: {pattern: /[0-9]/},
            }
        });

        $('input.six_digits').mask('SSSSSS', {
            'translation': {
                S: {pattern: /[0-9]/},
            }
        });

        $('input.phone').mask('+38(YSS) SSS-SS-SS', {
            placeholder: "+38(0__) ___-__-__", 'translation': {
                S: {pattern: /[0-9]/},
                Y: {pattern: /[0]/}
            }, clearIfNotMatch: true
        });
    },
    methods: {
        __t(phrase) {
            return window.__t(phrase);
        },
        saveData() {

            if (this.form_valid) {
                let myForm = document.getElementById('myForm');

                let formData = new FormData(myForm);

                var object = {};

                formData.forEach(function (value, key) {
                    let input_name = document.getElementsByName(key)[0].getAttribute("input_name");
                    object[key] = {"value": value, "type": "input" ,"name": input_name};
                });

                this.$emit('saveData', object)
            }
        },
        checkInput() {
            var _this = this;
            _this.form_valid = true;

            $("#myForm input").each(function () {
                let $input = $(this);

                if ($input.val() === '') {
                    _this.form_valid = false;
                }

                if ($input.hasClass('only_letters')) {
                    let val = $input.val().replace(/[^а-яА-ЯІіЇїЄєЁёҐґa-zA-Z\s\'\-]/g, '');
                    $input.val(val);
                }
                if ($input.hasClass('only_numbers')) {
                    let val = $input.val().replace(/[^0-9\'\-]/g, '');
                    $input.val(val);
                }
                if ($input.hasClass('email')) {
                    let val = $input.val().replace(/[^a-zA-Z\-\d\@\.\_]/g, '');
                    $input.val(val);
                    let charCode = e.which || e.keyCode;

                    if (charCode === 32) {
                        e.preventDefault();
                    }
                }

                if ($input.hasClass('ten_digits') && $input.val().length < 10) {
                    _this.form_valid = false;
                } else if ($input.hasClass('six_digits') && $input.val().length < 6) {
                    _this.form_valid = false;
                } else if ($input.hasClass('phone') && $input.val().length < 18) {
                    _this.form_valid = false;
                } else if ($input.hasClass('only_letters') && $input.val() === '') {
                    _this.form_valid = false;
                } else if ($input.hasClass('only_numbers') && $input.val() === '') {
                    _this.form_valid = false;
                }

            });
        },
        validEmail: function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        setPrevQuestion() {
            this.$emit('setPrevQuestion')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/type_form_step.vue